import { Component, Inject, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { TranslateService } from '@ngx-translate/core';
import { MCPHelperService } from 'projects/fe-insights-v2/src/app/service/MCPHelper.service';
import swal from 'sweetalert2';
import { CustomerManageOrdersService } from '../../service/cutomer-manage-order.service';
import { HelperService } from '../../service/helper.service';
import { orderStatusApproveRejet } from '../../components/manage-orders/order-management-model';


@Component({
  selector: 'app-approve-reject-order',
  templateUrl: './approve-reject-order.component.html',
  styleUrls: ['./approve-reject-order.component.scss']
})
export class ApproveRejectOrderComponent implements OnInit {
  orderStatusApproveRejet = orderStatusApproveRejet;
  manageCustomerData: any = [];
  customerData: any = [];
  addCustomerForm: FormGroup;
  authorId: any;

  constructor(
    public dialogRef: MatDialogRef<ApproveRejectOrderComponent>,
    private formBuilder: FormBuilder,
    private ApiService: CustomerManageOrdersService,
    public helper: HelperService,
    private translate: TranslateService,
    @Inject(MAT_DIALOG_DATA) public data: any) {
    let str = MCPHelperService.getDataFromStorage("credentials")
    const credentials = str;
    if (credentials) {
      const authUser: any = JSON.parse(credentials);
      this.authorId = authUser.person.id;
    }
    this.addCustomerForm = this.formBuilder.group({
      orderId : [this.data.id],
      status: [this.data.status],
      reason: ['',[Validators.required]],
      internalComment: ['', [Validators.required]],
    });

  }

  ngOnInit(): void {
    if (this.data.status == this.orderStatusApproveRejet.approved) {
      this.addCustomerForm.get("reason").clearValidators();
      this.addCustomerForm.get("reason").updateValueAndValidity();
    } 
    
  }

  


  onNoClick(): void {
    this.dialogRef.close(false);
  }

  onSubmit(): void {
    if(this.addCustomerForm.valid){
    this.ApiService.changeStatus(this.addCustomerForm.value).subscribe((res: any) => {
      if (res) {
          this.helper.toggleLoaderVisibility(false);
          this.dialogRef.close(true);
      }
    }, (err) => {
      this.helper.toggleLoaderVisibility(false);
      swal.fire(
        '',
        this.translate.instant(err?.error?.message),
        'info'
      );
    });
  }
}
}

